import { API_ENDPOINTS } from "@/api/services/attendance/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const ApprovalsListApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    getApprovals: builder.query({
      query: ({ key }) => ({url: API_ENDPOINTS.ATTENDANCE.GET_APPROVAL(key)}),
      providesTags: ["Approvals"],
    }),

    getOnSiteApprovals: builder.query({
      query: ({ key }) => ({url: API_ENDPOINTS.ATTENDANCE.GET_ONSITE_APPROVAL(key)}),
      providesTags: ["OnSiteApprovals"],
    }),

     approveOnSite: builder.mutation({
          query: ({status, empId, date, month, reason}) => ({
            url: API_ENDPOINTS.ATTENDANCE.PUT_ONSITE_APPROVAL(status, empId, date, month, reason),
            method: "PUT",
          }),
          invalidatesTags: ["OnSiteApprovals"],
        }),

    fetchOnsite: builder.query({
      transformResponse: (response) => response?.data,
      query: ({ referenceName }) => ({
        url: API_ENDPOINTS.ATTENDANCE.FETCH_ONSITE({ referenceName }),
        method: "GET",
      }),
    }),
  }),
});

export const { useGetApprovalsQuery, useGetOnSiteApprovalsQuery, useApproveOnSiteMutation, useFetchOnsiteQuery } = ApprovalsListApi;
